import React from 'react';
import './ButtonStyles.scss';
import { getNavigationPageLink } from '../../../utils';

interface IButtonProps {
  content: string;
  cloudBanner: boolean;
  handleClick: () => void;
}

const DiscoverButton = ({
  cloudBanner,
  handleClick,
  content
}: IButtonProps) => {
  let redirectLink = getNavigationPageLink(cloudBanner ? 'cloud' : 'rewards');
  return (
    <a
      className="btn discover-button-container"
      onClick={() => {
        handleClick();
        window.location.href = redirectLink;
      }}
    >
      <div
        className="cta cta_secondary discover-button"
        data-alt-text={content}
      >
        <span>{content}</span>
      </div>
    </a>
  );
};

export default DiscoverButton;